import React, { useContext, memo, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookOpen, faMapMarkerAlt, faUser, faCalendarAlt, faEdit, faBarcode,
} from '@fortawesome/free-solid-svg-icons';
import { foreignPropType } from '../../../constants/backend/propTypes';
import { CiatAppContext } from '../../../providers';
import { Control } from '../../../containers/newEditor/hook/control';

function Footer({
  created, updated, inspection, authority, author, headerProps,
}) {
  const { currentUser } = useContext(CiatAppContext);

  const crt = new Date(created);
  const upd = new Date(updated);
  const isSuperuser = currentUser.is_superuser;
  const [hoveredItem, setHoveredItem] = useState(null);
  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <div className="border rounded p-2 my-2 bg-light d-flex">
      {/* Якщо не суперюзер то бачимо лейбли */}
      {!isSuperuser && (
      <div className="mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center">
        <FontAwesomeIcon
          className="me-1"
          icon={faBookOpen}
        />
        {inspection && inspection.repr}
      </div>
      )}
      {isSuperuser && inspection && (
        <div className="mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center">
          <Control name="inspection" headerProps={headerProps} />
        </div>
      )}
      {/* Якщо не суперюзер то бачимо лейбли */}
      {!isSuperuser && 'authority' in headerProps.fields && authority && (
        <div className="mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center">
          <FontAwesomeIcon
            className="me-1"
            icon={faMapMarkerAlt}
          />
          {authority && authority.repr}
        </div>
      )}

      {isSuperuser && 'authority' in headerProps.fields && authority && (
        <div className="mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center">
          <Control name="authority" headerProps={headerProps} />
        </div>
      )}

      {'author' in headerProps.fields && (
      <div
        className={`mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center hover-box ${
          hoveredItem === 'author' ? 'hovered' : ''
        }`}
        onMouseEnter={() => handleMouseEnter('author')}
        onMouseLeave={handleMouseLeave}
      >
        <FontAwesomeIcon className="me-1" icon={faUser} />
        {author && author.repr}
      </div>
      )}

      {!!created && (
        <div
          className={`mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center hover-box ${
            hoveredItem === 'created' ? 'hovered' : ''
          }`}
          onMouseEnter={() => handleMouseEnter('created')}
          onMouseLeave={handleMouseLeave}
        >
          <FontAwesomeIcon className="me-1" icon={faCalendarAlt} />
          {crt.toLocaleString('uk')}
        </div>
      )}

      {!!updated && (
        <div
          className={`mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center hover-box ${
            hoveredItem === 'updated' ? 'hovered' : ''
          }`}
          onMouseEnter={() => handleMouseEnter('updated')}
          onMouseLeave={handleMouseLeave}
        >
          <FontAwesomeIcon className="me-1" icon={faEdit} />
          {upd.toLocaleString('uk')}
        </div>
      )}

      {headerProps.data.id && (
        <div
          className={`mx-1 flex-fill small fst-italic d-flex justify-content-center align-items-center hover-box ${
            hoveredItem === 'id' ? 'hovered' : ''
          }`}
          onMouseEnter={() => handleMouseEnter('id')}
          onMouseLeave={handleMouseLeave}
        >
          <FontAwesomeIcon className="me-1" icon={faBarcode} />
          {headerProps.data.id}
        </div>
      )}
    </div>
  );
}

Footer.propTypes = {
  created: PropTypes.string,
  updated: PropTypes.string,
  inspection: foreignPropType,
  authority: foreignPropType,
  author: foreignPropType,
  headerProps: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number,
    }),
    fields: PropTypes.shape({}),
  }),
};

Footer.defaultProps = {
  created: null,
  updated: null,
  inspection: null,
  authority: null,
  author: null,
  headerProps: { data: {} },
};

export default memo(Footer);
